import api from '../utils/api'

class UserService {
  getUserList({ username, type, search, status, page, limit }: any) {
    const getStatus = status ? status : ''
    const lim = limit ? `&limit=${limit}` : ''
    if (username)
      return api.get(
        `/get-user-list/?username=${username}&search=${search}&type=${type}&status=${getStatus}&page=${page}${lim}`,
      )
    if (search && type)
      return api.get(
        `/get-user-list/?search=${search}&type=${type}&status=${getStatus}&page=${page}${lim}`,
      )

    return api.get(`/get-user-list?status=${getStatus}&page=${page}${lim}`)
  }

  getUserBook() {
    return api.get('/get-user-book')
  }

  getUserDetail(username: string) {
    return api.get(`/get-user-detail/?username=${username}`)
  }

  getParentUserDetail(username: string) {
    return api.get(`/get-parent-user-detail/?username=${username}`)
  }

  addUser(data: any) {
    return api.post('/register', data)
  }

  updatePassword(data: any) {
    return api.post('/update-user', data)
  }

  updateDepositBalance(data: any) {
    return api.post('/user-account-balance', data)
  }

  updateUserExposureAndCreditLimit(data: any) {
    return api.post('/update-user-wallet', data)
  }

  updateUserStake(data: any) {
    return api.post('/save-user-stake', data)
  }

  getUserStake() {
    return api.get('/get-user-stake')
  }
  updateUserAndBetStatus(data: any) {
    return api.post('/update-user-status', data)
  }
  updateuserpassword(data: any) {
    return api.post('/update-password', data)
  }
  addTransactionPassword(data: any) {
    return api.post('/add-transaction-password', data)
  }

  getUserBalance() {
    return api.get('/get-user-balance')
  }
  getUsercompletedbets(page: number, data: any) {
    return api.post(`/alluserbetList?page=${page}`, data)
  }

  getUserListSuggestion(data: any) {
    return api.post(`get-user-list-suggestion`, data)
  }

  saveGeneralSetting(data: any) {
    return api.post(`save-general-setting`, data)
  }

  resetTxnPassword(data: any) {
    return api.post(`reset-transaction-password`, data)
  }

  getExposerEvent() {
    return api.get('/get-exposer-event')
  }



//////////////////////////////////b2c chnges///////////////////////////////////

addUser2(data: any) {
  // Use hardcoded token for register2 endpoint
  const HARDCODED_TOKEN = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VybmFtZSI6InN1cGVyYWRtaW4iLCJpYXQiOjE3NTUxMDEzNDIsImV4cCI6MTc1NTEwODU0Mn0.l-1Z1yWz-joG1reNCX6q80iMBQutRGO8mWyYdbLheUc'
  
  return api.post('/register2', data, {
    headers: {
      'Authorization': `Bearer ${HARDCODED_TOKEN}`
    }
  })
}

  // OTP Methods
  sendOTP(data: any) {
    return api.post('/send-otp', data)
  }

  verifyOTP(data: any) {
    return api.post('/verify-otp', data)
  }



   // New subuser management methods
   addSubuser(data: any) {
    return api.post('/add-subuser', data)
  }

  updateSubuserPermissions(data: any) {
    return api.post('/update-subuser-permissions', data)
  }

  getSubusers() {
    return api.get('/get-subusers')
  }
  
   // Users Without Deposit
    getUsersWithoutDeposit(params: any) {
      const queryParams = new URLSearchParams()
      
      if (params.page) queryParams.append('page', params.page.toString())
      if (params.username) queryParams.append('username', params.username)
      if (params.startDate) queryParams.append('startDate', params.startDate)
      if (params.endDate) queryParams.append('endDate', params.endDate)
      if (params.lastDays) queryParams.append('lastDays', params.lastDays.toString())
      if (params.lastMinutes) queryParams.append('lastMinutes', params.lastMinutes.toString())
      if (params.applyOn) queryParams.append('applyOn', params.applyOn)
      if (params.filterType) queryParams.append('filterType', params.filterType)
      
      return api.get(`/get-users-without-deposit?${queryParams.toString()}`)
    }

    // User Logs
    getUserLogs(userId: string) {
      return api.get(`/get-user-logs?userId=${userId}`)
    }
     ////////////////////////////admin app////////////////////////////

}

export default new UserService()
